import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LayoutComponent } from 'app/layout/layout.component';
import { PermissionKeys } from './config/permissions-key';
import { PermissionGuard } from './core/guards/permission.guard';
import { LoginFailedComponent } from './login-failed/login-failed.component';
import { NotPermittedComponent } from './not-permitted/not-permitted.component';
import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component';

export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'operations/quotation'
    },
    {
        path: '',
        canActivate: [MsalGuard],
        canActivateChild: [MsalGuard],
        component: LayoutComponent,
        children: [

            // // Dashboards
            {
                path: 'dashboards', children: [
                    {
                        path: 'analytics',
                        data: { permission: PermissionKeys.AnalyticsViewKey },
                        canActivate: [PermissionGuard],
                        loadChildren: () => import('app/modules/admin/dashboards/analytics/analytics.routes')
                    },
                    {
                        path: 'finance',
                        data: { permission: PermissionKeys.FinanceViewKey },
                        canActivate: [PermissionGuard],
                        loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')
                    },
                ]
            },

            // Master Data
            {
                path: 'master-data',
                loadChildren: () => import('app/modules/master-data/master-data.routes')
            },

            //configurations
            {
                path: 'configurations', children: [
                    {
                        path: 'applicationconfiguration',
                        data: { permission: PermissionKeys.ApplicationConfigurationViewKey },
                        canActivate: [PermissionGuard],
                        loadChildren: () => import('app/modules/admin/configurations/applicationconfiguration/application-configuration.routes')
                    },
                    {
                        path: 'permissions',
                        loadChildren: () => import('app/modules/admin/configurations/permissions/permissions.routes')
                    },
                    {
                        path: 'invoice-approval-configuration',
                        data: { permission: PermissionKeys.InvoiceApprovalConfigurationViewKey },
                        canActivate: [PermissionGuard],
                        loadChildren: () => import('app/modules/admin/configurations/invoice-approval-configuration/invoice-approval-configuration.routes')
                    }

                ]
            },
            // operations
            {
                path: 'operations', children: [
                    {
                        path: 'quotation',
                        loadChildren: () => import('app/modules/admin/operations/quotation/quotation.routes')
                    },
                    { path: 'purchase-order', loadChildren: () => import('app/modules/admin/operations/purchase-order/purchase-order.routes') },
                    {
                        path: 'jobs',
                        data: { permission: PermissionKeys.ShipmentsViewKey },
                        canActivate: [PermissionGuard],
                        loadChildren: () => import('app/modules/admin/operations/jobs/jobs.routes')
                    }
                ]
            },
            //finance
            {
                path: 'finance',
                loadChildren: () => import('app/modules/admin/finance/finance.routes')
            },
            //report
            {
                path: 'reports',
                loadChildren: () => import('app/modules/reports/reports.routes')
            },

        ]
    },
    {
        path: 'login-failed',
        component: LoginFailedComponent,
    },
    {
        path: 'permission-denied',
        component: NotPermittedComponent,
    },
    {
        path: 'service-unavailable',
        component: ServiceUnavailableComponent,
    },
    { path: '**', redirectTo: 'dashboards/analytics' }
];
